import { PromotionProvidersResponse } from '@chargeafter/payment-types';
import { BaseModalData, SDKConfig } from '@chargeafter/types-sdk';
import { WidgetItem, Widgets } from '@chargeafter/types-session';

import { convertSdkConfigToMerchantDetails } from '../utils/merchantDetailsMiddleware';

let widgets: Widgets = {};
let config: SDKConfig;
let isInitialized = false;
let sdkInitializedPromise: Promise<void> | undefined;
let basePromotionModalData: Omit<BaseModalData, 'promotion'>;

const itemsToUpdate: Map<string, WidgetItem> = new Map();

const promotionProviderData: Map<
  string,
  { data: PromotionProvidersResponse; timestamp: number }
> = new Map();

export const store = {
  get widgets() {
    return widgets;
  },
  set widgets(value: Widgets) {
    widgets = value;
  },

  get config() {
    return config;
  },

  set config(value: SDKConfig) {
    config = convertSdkConfigToMerchantDetails(value);
  },

  get isInitialized() {
    return isInitialized;
  },

  set isInitialized(value: boolean) {
    isInitialized = value;
  },

  get basePromotionModalData() {
    return basePromotionModalData;
  },

  set basePromotionModalData(value: Omit<BaseModalData, 'promotion'>) {
    basePromotionModalData = value;
  },

  get sdkInitializedPromise() {
    return sdkInitializedPromise;
  },

  set sdkInitializedPromise(value: Promise<void> | undefined) {
    sdkInitializedPromise = value;
  },

  get itemsToUpdate(): Map<string, WidgetItem> {
    return itemsToUpdate;
  },

  get promotionProviderData(): Map<
    string,
    { data: PromotionProvidersResponse; timestamp: number }
  > {
    return promotionProviderData;
  },
};
